<template>
    <div class="cta">
        <div class="cta__text"><prismic-rich-text :field="slice.primary.cta_text" /></div>
        <button class="cta__primary"><prismic-link :field="slice.primary.cta_button_link">{{ slice.primary.cta_button_label }}</prismic-link></button>
        <button class="cta__secondary"><prismic-link :field="slice.primary.secondary_button_link">{{ slice.primary.secondary_button_label }}</prismic-link></button>
    </div>
</template>


<script>
    export default {
        props: ['slice'],
        name: 'call_2_action'
    }
</script>

<style lang="scss">
    .cta {
        background: #F7F8FF;
        padding: 25px;
        margin-bottom: 25px;
        text-align: center;
        &__text {
            h3 {
                font-size: 25px;
            }
        }
        &__primary {
            background: #0185c9;
            border-radius: 4px;
            a {
                color: #ffffff;
            }
        }
        &__secondary {

        }
    }
</style>
